import React from "react";
import "./Photos.css";


export default function Photos(props) {

    if (props.photos) {
        console.log(props.photos);
        return (
            <section className="Photos">
                <div className="row g-3">
                    {props.photos.map(function (photo, index){
                        return (
                            <div className="col-12 col-sm-6 col-md-4" key={index}>
                                <a href={photo.src.original} target="_blank" rel="noreferrer">
                                    <img src={photo.src.landscape} className="img-fluid" alt="/" />
                                </a>
                            </div>
                        );
                    })}
                </div>
                <p>{"(click the images for the originals)"}</p>
            </section>
        );
    } else {
        return null;
    }
}